export type TriviaQuestionType = "multiple-choice" | "text-input";

export interface TriviaQuestion {
  day: number;
  question: string;
  choices?: string[]; // Optional for text-input
  correctIndex?: number; // Optional for text-input
  answerText?: string; // For text-input questions
  type: TriviaQuestionType;
}

export const triviaQuestions: TriviaQuestion[] = [
  {
    day: 1,
    question: "Our relationship started with Hinge. What was the topic that started our first conversation?",
    choices: ["Not being a dry texter", "iPhone 8ball", "Spotify playlist", "Snowboarding"],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 2,
    question: "Which planet is my name derived from?",
    choices: ["Venus", "Mars", "Earth", "Jupiter"],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 3,
    question: "You bought me the newly remastered game from the Elder Scrolls series. What is it called?",
    choices: [
      "The Elder Scrolls II: Daggerfall",
      "The Elder Scrolls IV: Oblivion",
      "The Elder Scrolls V: Skyrim",
      "The Elder Scrolls III: Morrowind"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 4,
    question: "After our first date at minigolf, we chilled in a parking lot. Later, you needed to use the washroom. Where did we go so you could use the washroom?",
    choices: [
      "Subway",
      "Starbucks",
      "Tim Hortons",
      "McDonald's"
    ],
    correctIndex: 3,
    type: "multiple-choice"
  },
  {
    day: 5,
    question: "During my birthday weekend, we spontaneously decided to go to a Raptors game because a special event was happening. What was the name of that event?",
    choices: [
      "Fan Appreciation Night",
      "Drake Night",
      "OVO Day",
      "Opening Night"
    ],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 6,
    question: "When did I start working on this birthday calendar project?",
    choices: [
      "June 1",
      "May 10",
      "March 15",
      "April 25"
    ],
    correctIndex: 3,
    type: "multiple-choice"
  },
  {
    day: 7,
    question: "Mangaka Naoki Urasawa is known for creating 'Monster', a psychological thriller about a doctor chasing a serial killer. What other Urasawa work have I been begging you to watch?",
    choices: [
      "Pluto",
      "Fullmetal Alchemist",
      "Berserk",
      "20th Century Boys"
    ],
    correctIndex: 0,
    type: "multiple-choice"
  },
  {
    day: 8,
    question: "What is the license plate number on my Corolla?",
    choices: [
      "CCJF427",
      "CJFF427",
      "CCJF247",
      "CCFJ247"
    ],
    correctIndex: 0,
    type: "multiple-choice"
  },
  {
    day: 9,
    question: "What is my phone number?",
    choices: [
      "647-803-7608",
      "647-803-7607",
      "647-803-7606",
      "647-830-7607"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 10,
    question: "What is my full name?",
    answerText: "Marco Elijah Roshan Vethanayagam",
    type: "text-input"
  },
  {
    day: 11,
    question: "On December 4, we became official after I gave you a gift box with a custom made flower and some pictures of you. Which of my friends helped me by printing those pictures?",
    choices: [
      "Marvin",
      "Albert",
      "Daniel",
      "Michael"
    ],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 12,
    question: "On November 15, I gave you a Pokémon plush. Which Pokémon is it?",
    choices: [
      "Squirtle",
      "Celebi",
      "Togepi",
      "Pikachu"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 13,
    question: "What is the name of the first Escape Simulator map we played together?",
    choices: [
      "The Devilish Diorama",
      "Deluxe Museum Heist",
      "The Wankil Bank Heist",
      "The Miniature Escape"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 14,
    question: "Our first date was a minigolf date where I won. What was the final score?",
    choices: [
      "60-62",
      "57-61",
      "55-59",
      "48-53"
    ],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 15,
    question: "After your work party, I got you an Uber to a parking lot where I was waiting to drive you home. Where was that parking lot?",
    choices: [
      "Burger King",
      "McDonald's",
      "Osmow's",
      "Tim Hortons"
    ],
    correctIndex: 3,
    type: "multiple-choice"
  },
  {
    day: 16,
    question: "After I messed up, I bought you a teddy bear to help reconcile. How many teddy bears have I bought you in total?",
    answerText: "2",
    type: "text-input"
  },
  {
    day: 17,
    question: "When heading back home from Union, we met one of my old Ottawa friends by complete chance. Who was it?",
    choices: [
      "Andy",
      "Chetan",
      "Avaneesh",
      "Luka"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 18,
    question: "We're watching Love Island. What is one of the most iconic moments from that show?",
    choices: [
      "Casa Amor",
      "Ace's Dance Company",
      "Huda Mamacita",
      "The Hideaway Reveal"
    ],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 19,
    question: "For our final stay in Osaka, we booked a themed Airbnb. What was the theme?",
    answerText: "Hello Kitty",
    type: "text-input"
  },
  {
    day: 20,
    question: "We played a co-op story game about a couple being turned into miniature figures to solve their relationship issues. What is the name of the game?",
    answerText: "It Takes Two",
    type: "text-input"
  },
  {
    day: 21,
    question: "When we get our own place, which section of the house have I been saying I want to turn into my own man cave?",
    choices: [
      "Garage",
      "Basement",
      "Den",
      "Attic"
    ],
    correctIndex: 1,
    type: "multiple-choice"
  },
  {
    day: 22,
    question: "Growing up, I did a lot of things: sports, extracurriculars, etc. Which of the following did I NOT do?",
    choices: [
      "Badminton",
      "Figure Skating",
      "Baseball",
      "Chess"
    ],
    correctIndex: 2,
    type: "multiple-choice"
  },
  {
    day: 23,
    question: "Me, Albert, and Marvin started a clothing company as a side project. What is the name of this brand?",
    answerText: "Elicit Collection",
    type: "text-input"
  },
  {
    day: 24,
    question: "I bought you a controller to play games with me. What is the brand?",
    answerText: "Xbox",
    type: "text-input"
  },
  {
    day: 25,
    question: "When we were first talking, I told you to make a Steam account and gave you a name recommendation. What is the account name?",
    answerText: "anitamaxwynnnnnnn",
    type: "text-input"
  },
  {
    day: 26,
    question: "When we first started talking, you played a single player game about maintaining a farm and planting crops, and we had a joke where you had to get a certain amount of coins before we hang out again. What was the name of the game?",
    answerText: "Rusty's Retirement",
    type: "text-input"
  },
  {
    day: 27,
    question: "We played our first co-op game together on Nov 5 where we completed puzzles together by describing what we see and communicating that through Discord. What was the game called?",
    answerText: "We Were Here",
    type: "text-input"
  },
  {
    day: 28,
    question: "During my birthday weekend, we went to a VR arcade and played a mythical escape room where we brewed magical potions, threw bones at dogs, and used a ballista to shoot down a mythical creature. What was this mythical creature?",
    answerText: "Dragon",
    type: "text-input"
  },
  {
    day: 29,
    question: "During my 2024 white elephant, I got a custom 3D printed gift from Jodie which depicted a cartoonish meme character from TikTok whose presence is considered nonchalant. What is this character's name?",
    answerText: "Chill Guy",
    type: "text-input"
  },
  {
    day: 30,
    question: "Who is the most important person in my life?",
    choices: [
      "My gamer queen Anitamaxwynnnnn",
      "My girlfriend Anita Chaseendran",
      "Anita Bonita",
      "My future wife Anita Vethanayagam",
      "All of the Above"
    ],
    correctIndex: 4,
    type: "multiple-choice"
  }
];